import type { SimpleBounds } from '@/types';

export const isPointWithinBounds = (point: [number, number], bounds: SimpleBounds): boolean => {
  const [x, y] = point;

  return x >= bounds.minX && x <= bounds.maxX && y >= bounds.minY && y <= bounds.maxY;
};
